import React from "react";

export default function SeP({ finalPassword }) {
  function copy() {
    let copyText = document.getElementById("finalPassword");
    copyText.select();
    copyText.setSelectionRange(0, 999990);
    document.execCommand("copy");

    alert("your secure password copied successfully     " + copyText.value);
  }
  return (
    <>
      <center>
        <div className="secure_container">
          <div className="secure_heading_sep">
            <p className="secure_heading_info_sep">
              Never share your password with anyone.
            </p>
          </div>

          <div className="secure_input_sep">
            <input
              type="text"
              readonly="true"
              value={finalPassword}
              id="finalPassword"
            />
            <br />
            <button type="submit" onClick={copy}>
              Copy
            </button>
          </div>

          <p className="small_sep">
            We never save your password . Feel free to use our app
          </p>
          <br />
        </div>
      </center>
    </>
  );
}
